import type { CommunitySlim } from 'models';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- break circular dependency
import type { CommunityLabelInValue } from 'features/communities/components';

export type CreateCommunityOptionSource = Pick<CommunitySlim, 'id' | 'name' | 'organizationId'>;

export const createCommunityOption = (community: CreateCommunityOptionSource): CommunityLabelInValue => ({
  label: community.name,
  optionLabel: community.name,
  organization: { id: community.organizationId },
  value: community.id,
});
